// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__JttyM","content":"LayoutSettings_content__3fEzm"};